import React from 'react';
import { withRouter } from '../../../RouterCompatibility';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import FinanceReportList from './FinanceReportList';
import { actions } from './FinanceReportList.actions';
import {
    mainSelector,
    getHeaderName
} from './FinanceReportList.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    headerNames: getHeaderName,
    list: mainSelector
});

const FinanceReportListComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state),
            page: state.financeOperations.page,
            total: state.financeOperations.total,
            loading: state.financeOperations.loading
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            searchAdvertisers: actions.searchAdvertisers,
            getFinanceOperations: actions.getFinanceOperations
        };
    }
)(withRouter(FinanceReportList));

export default FinanceReportListComponent;
